import { render, staticRenderFns } from "./InspectList.vue?vue&type=template&id=203785bd&scoped=true"
import script from "./InspectList.vue?vue&type=script&lang=js"
export * from "./InspectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203785bd",
  null
  
)

export default component.exports